// @mui material components
import Card from "@mui/material/Card";
import React from "react";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";


import { Box, List, ListItem, Typography } from "@mui/material";

function PrivacyPolicy() {

  return (
    <SoftBox>
      <SoftBox>
        <Card sx={{ minHeight: "100vh" }}>
          <SoftBox sx={{ p: 2 }}>
            <SoftTypography variant="body1">
              <strong>Effective Date:</strong>
              <span style={{ fontWeight: 400 }}> April, 2025</span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 2 }}>
              <strong>G2 Web Development LLC</strong>
              <span style={{ fontWeight: 400 }}>
                {" "}
                ("we," "our," or "us") respects your privacy and is committed to
                protecting it through this Privacy Policy.
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 2 }}>
              <span style={{ fontWeight: 400 }}>
                This Privacy Policy explains how the CC&amp;I Field Reporting
                app ("App") collects, uses, and protects your information.
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 3 }}>
              <strong>1. Information We Collect</strong>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 1 }}>
              <span style={{ fontWeight: 400 }}>
                We may collect the following information when you use the App:
              </span>
            </SoftTypography>

            <List sx={{ pl: 4 }}>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Inspection reports entered by users (including text, images, and
                form data)
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Project details and site contact information
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                User account information (name, email, role)
              </ListItem>
            </List>

            <SoftTypography variant="body1">
              <span style={{ fontWeight: 400 }}>
                The App does not collect personal financial information, health
                information, or personal device information beyond what is
                necessary for inspection reporting.
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 3 }}>
              <strong>2. How We Use Information</strong>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 1 }}>
              <span style={{ fontWeight: 400 }}>
                We use collected information to:
              </span>
            </SoftTypography>

            <List sx={{ pl: 4 }}>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Enable the creation, editing, review, and approval of field
                inspection reports
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Facilitate syncing of inspection reports to cloud services when
                available
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Manage user roles and access rights within the App and web
                dashboard
              </ListItem>
            </List>

            <SoftTypography variant="body1">
              <span style={{ fontWeight: 400 }}>
                We do not sell, rent, or share personal information with third
                parties for marketing purposes.
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 3 }}>
              <strong>3. Data Security</strong>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 1 }}>
              <span style={{ fontWeight: 400 }}>
                We implement appropriate security measures to protect your
                information. However, no electronic storage or transmission is
                100% secure.
              </span>
              <br />
              <span style={{ fontWeight: 400 }}>
                We encourage users to safeguard their login credentials and
                device access.
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 3 }}>
              <strong>4. User Rights</strong>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 1 }}>
              <span style={{ fontWeight: 400 }}>Users may request:</span>
            </SoftTypography>

            <List sx={{ pl: 4 }}>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Access to the information collected about them
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Correction of any inaccurate information
              </ListItem>
              <ListItem sx={{ display: "list-item", fontWeight: 400 }}>
                Deletion of their user account (subject to company approval
                policies)
              </ListItem>
            </List>

            <SoftTypography variant="body1">
              <span style={{ fontWeight: 400 }}>
                Requests can be made by contacting our support team (contact
                information below).
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 3 }}>
              <strong>5. Changes to This Policy</strong>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 1 }}>
              <span style={{ fontWeight: 400 }}>
                We may update this Privacy Policy from time to time. Updates
                will be posted on our Support page.
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 3 }}>
              <strong>6. Contact Us</strong>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 1 }}>
              <span style={{ fontWeight: 400 }}>
                If you have any questions about this Privacy Policy or your
                information, contact:
              </span>
            </SoftTypography>

            <SoftTypography variant="body1" sx={{ mt: 1 }}>
              <strong>G2 Web Development LLC</strong>
              <br />
              <span style={{ fontWeight: 400 }}>
                Email: info@g2webdevelopment.com
              </span>
              <br />
              <span style={{ fontWeight: 400 }}>Phone: +1(864)561-5380</span>
              <br />
              <span style={{ fontWeight: 400 }}>
                Website:{" "}
                <a
                  href="https://g2webdevelopment.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://g2webdevelopment.com
                </a>
              </span>
            </SoftTypography>
          </SoftBox>
        </Card>
      </SoftBox>
    </SoftBox>
  );
}

export default PrivacyPolicy;
